/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import autobind from 'react-autobind';
import { withRouter, Redirect } from 'react-router-dom';
import DatePicker from "react-datepicker";
import { Container, Row, Col } from 'reactstrap';
import Select from 'react-select';
import Alert from '../../components/Errors/Alert'
import Header from "../../components/Header";
import SuperAdminHeader from "../../components/Header/SuperAdmin";
import Subheader from "../../components/Subheader";
import Footer from "../../components/Footer";
import * as actions from "../../redux/actions"
import ErrorHelper from '../../components/ErrorHelper';
import { ITEMS_PER_PAGE } from "../../components/Pagination/Pagination";
import Switch from 'react-toggle-switch';

class NewStory extends PureComponent {

  constructor(props) {
    super(props);
    autobind(this);
    this._isMounted = false;

    this.state = {
      name: '',
      description: '',
      published: false,
      category: null,
      categoryOptions: [],
      acceptedImage: [],
      storage: '',
      traffic: '',
      endDate: null,
      privateStory: false,
      storyAccessLink: false,
      dataCollection: false,
      validationFieldsTouched: {
        name: false,
        category: false,
        description: false,
        storage: false,
        traffic: false,
        endDate: false,
      }
    };

  }

  componentDidMount() {
    this._isMounted = true;
    const { allStories, getStories, getCategories } = this.props;
    if (allStories.length === 0) {
      getStories().catch((error) => {
        console.error("Loading stories failed", error);
      });
    }
    getCategories('FURNITURE', (categories) => {

      if (categories && this._isMounted) {
        this.setState({
          category: {
            value: categories[0]._id,
            label: categories[0].name
          }
        })
        const categoryOptions = [
          {
            value: null, label: "Select collection"
          }
        ];

        const options = categories.filter(category => category.parent == null).map(category => ({
          value: category._id, label: category.name
        }));

        categoryOptions.push(...options);

        this.setState({
          categoryOptions
        })

        this.setState({
          category: {
            value: null,
            label: "Select collection"
          }
        })
      }
    });
  }

  componentDidUpdate(prevProps) {
    ErrorHelper.scrollOnError(this.props, prevProps, ['errorInStories']);
  }

  componentWillUnmount() {
    this._isMounted = false;
    const { clearErrors } = this.props;
    clearErrors();
  }

  cancel() {
    const { history } = this.props;
    history.push("/stories");
  }

  uploadStory() {
    const { addStory } = this.props;
    const {
      name, description, category, acceptedImage,
      published, storage, traffic, endDate, privateStory, storyAccessLink, dataCollection
    } = this.state;

    const dataToUpload = {
      name,
      description,
      category: category.value,
      storyPath: acceptedImage[0],
      published,
      storage,
      traffic,
      endDate,
      privateStory,
      storyAccessLink,
      dataCollection
    };

    addStory(dataToUpload)
      .then(() => this.resetValidationTouched())
      .catch((error) => {
        console.error(error);
      });

    this.updatePaginationData();
  }

  updatePaginationData() {
    const { storiesPaginateDataChanged, sortByIndex, fileteredStoriesCount } = this.props;
    const lastPage = Math.floor(fileteredStoriesCount / ITEMS_PER_PAGE);
    const finalPagination = {
      sortByIndex,
      filterByIndex: 0,
      query: ""
    }

    if (sortByIndex !== 0) {
      finalPagination.currentPage = 0;
    } else {
      finalPagination.currentPage = lastPage;
    }

    storiesPaginateDataChanged(finalPagination);
  }

  onDropProductImage(acceptedFiles, rejectedFiles) {
    this.setState({
      acceptedImage: acceptedFiles
    });
  }

  renderProductImageUpload() {
    const { acceptedImage } = this.state;
    if (acceptedImage.length > 0) {
      return (
        <div className="d-flex justify-content-center">
          <div className="product-upload__image-container">
            <div className="product-upload__image-edit">
              <Dropzone
                onDrop={(accepted, rejected) => { this.onDropProductImage(accepted, rejected) }}
                className="s7-upload"
              />
            </div>
            <img src={acceptedImage[0].preview} className="product-upload__image" alt="Product" />
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="d-flex justify-content-center mb-2">
          <Dropzone
            onDrop={(accepted, rejected) => { this.onDropProductImage(accepted, rejected) }}
            className="btn btn-rounded btn-space btn-secondary"
          >
            Upload Story Cover
          </Dropzone>
        </div>
        <p className="text-center mb-1"><em>Recommended: 960x270px</em></p>
      </div>
    );
  }

  updateField(field, value) {
    this.setState((prevState) => ({
      [field]: value,
      validationFieldsTouched: Object.assign(prevState.validationFieldsTouched, { [field]: true })
    }));
  }

  togglePrivateStory = () => {
    this.setState(prevState => {
      return {
        privateStory: !prevState.privateStory
      };
    });
  };

  toggleStoryAccessLink = () => {
    this.setState(prevState => {
      return {
        storyAccessLink: !prevState.storyAccessLink
      };
    });
  };

  toggleDataCollection = () => {
    this.setState(prevState => {
      return {
        dataCollection: !prevState.dataCollection
      };
    });
  };

  resetValidationTouched = () => {
    this.setState({
      validationFieldsTouched: {
        name: false,
        category: false,
        description: false,
        storage: false,
        traffic: false,
        endDate: false,
      }
    })
  }

  render() {
    const { user, errorInStories, requestingStories, completedStories } = this.props;
    const { name, description, category, categoryOptions, traffic, storage, endDate, validationFieldsTouched } = this.state;
    if (!user) {
      return <Redirect to="/login" />
    }
    if (user.role === 3) {
      return <Redirect to="/s/dashboard" />
    }
    if (completedStories) {
      return <Redirect to="/stories" />
    }

    const renderedImageUpload = this.renderProductImageUpload();
    const userIsSuperAdmin = user && user.role === 3;
    return (
      <div className={`${userIsSuperAdmin ? "superadmin stories" : "stories"}`}>
        {userIsSuperAdmin ? <SuperAdminHeader /> : <Header />}
        <Subheader
          breadcrumbs={[{
            title: "StoryBoard", link: "/stories"
          }, "New Story"]}
        />
        <div className="stastistics-subheader">
          <Container className="pb-5">
            {errorInStories ? <Alert message={errorInStories} /> : null}
            <Row className="xs-gutters">
              <Col xs="5">
                <div className="pb-1 height-100">
                  <div className="panel panel-default mb-0 height-100">
                    <div className="panel-body panel-body--md upload-product-image-box d-flex align-items-center justify-content-center">
                      {renderedImageUpload}
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs="7">
                <div className="panel panel-default mb-1">
                  <div className="panel-body panel-body--md">
                    <Row>
                      <Col xs="6">
                        <div className="form-group row no-gutters">
                          <label htmlFor="inputEmail3" className="col-3 col-form-label pr-1">Name*</label>
                          <div className="col-9 pt-1">
                            <input
                              type="text"
                              placeholder="Enter name"
                              className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClass("name", errorInStories, validationFieldsTouched.name)}`}
                              value={name}
                              onChange={e => this.updateField("name", e.target.value)} />
                          </div>
                        </div>
                      </Col>
                      <Col xs="6">
                        <div className="form-group row no-gutters">
                          <label htmlFor="inputEmail3" className="col-4 col-form-label pr-1">Collection*</label>
                          <br />
                          <div className="col-8 pt-1">
                            <Select
                              name="product-category"
                              className={`advanced-select ${ErrorHelper.getValidationErrorClass("category", errorInStories, validationFieldsTouched.category)}`}
                              value={category}
                              defaultValue={{
                                label: "Select collection", value: 0
                              }}
                              onChange={selectedOption => this.updateField("category", selectedOption)}
                              options={categoryOptions}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                </div>
                <div className="panel panel-default mb-1">
                  <div className="panel-body panel-body--md">
                    <Row>
                      <Col>
                        <div className="form-group row no-gutters">
                          <label htmlFor="inputEmail3" className="col-3 col-form-label pr-1">Description*</label>
                          <div className="col-9 pt-1">
                            <textarea
                              className={`form-control ${ErrorHelper.getValidationErrorClass("description", errorInStories, validationFieldsTouched.description)}`}
                              rows="5"
                              placeholder="None"
                              value={description}
                              placeholder="No more than 1000 characters"
                              maxLength="1000"
                              onChange={e => this.updateField("description", e.target.value)}
                              style={{
                                minHeight: "90px"
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="xs-gutters">
              <div className="col-12">
                <div className="panel panel-default mb-1">
                  <div className="panel-body panel-body--md">
                    <Row>
                      <Col xs="4">
                        <div className="form-group row no-gutters">
                          <label htmlFor="startsOn" className="col-3 col-form-label pr-1">Storage*</label>
                          <div className="col-9 pt-1">
                            <input
                              type="text"
                              placeholder="Storage in MB"
                              className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClass("storage", errorInStories, validationFieldsTouched.storage)}`}
                              value={storage}
                              onChange={e => this.updateField("storage", e.target.value)} />
                          </div>
                        </div>
                      </Col>
                      <Col xs="4">
                        <div className="form-group row no-gutters">
                          <label htmlFor="startsOn" className="col-3 col-form-label pr-1">Traffic*</label>
                          <div className="col-9 pt-1">
                            <input
                              type="text"
                              placeholder="Traffic in MB"
                              className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClass("traffic", errorInStories, validationFieldsTouched.traffic)}`}
                              value={traffic}
                              onChange={e => this.updateField("traffic", e.target.value)} />
                          </div>
                        </div>
                      </Col>
                      <Col xs="4">
                        <div className="form-group row no-gutters">
                          <label htmlFor="endDate" className="col-3 col-form-label pr-1">End date*</label>
                          <div className="col-9 pt-1">
                            <DatePicker
                              dateFormat="DD/MM/YYYY"
                              selected={endDate}
                              onChange={date => this.updateField("endDate", date)}
                              className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClass("endDate", errorInStories, validationFieldsTouched.endDate)}`}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Row>
            <Row className="xs-gutters">
              <div className="col-12">
                <div className="panel panel-default mb-1">
                  <div className="panel-body panel-body--md">
                    <Row>
                      <Col xs="4">
                        <div className="form-group row no-gutters">
                          <label htmlFor="privateStory" className="col-7 col-form-label">Private Story Status:</label>
                          <div className="col-5 d-flex align-items-center">
                            <Switch id="privateStory" onClick={this.togglePrivateStory}
                              on={this.state.privateStory} className="switch-button switch-button-xs"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs="4">
                        <div className="form-group row no-gutters">
                          <label htmlFor="storyAccessLink" className="col-7 col-form-label">Story Access Link:</label>
                          <div className="col-5 d-flex align-items-center">
                            <Switch id="storyAccessLink" onClick={this.toggleStoryAccessLink}
                              on={this.state.storyAccessLink} className="switch-button switch-button-xs"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs="4">
                        <div className="form-group row no-gutters">
                          <label htmlFor="dataCollection" className="col-7 col-form-label">Data Collection:</label>
                          <div className="col-5 d-flex align-items-center">
                            <Switch id="dataCollection" onClick={this.toggleDataCollection}
                              on={this.state.dataCollection} className="switch-button switch-button-xs"
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Row>

          </Container>

        </div>
        <Container className="mt-5">

          <Row className="xs-gutters mt-2">
            <Col xs="8 btn-semi-dark" />
            <Col xs="2">
              <button className="btn btn-semi-dark btn-block btn-lg upload-product__control-panel-item text-uppercase" onClick={this.cancel}>Cancel</button>
            </Col>
            <Col xs="2">
              <button
                className="btn btn-primary btn-lg btn-block upload-product__control-panel-item text-uppercase"
                disabled={requestingStories}
                onClick={this.uploadStory}
              >
                {requestingStories ? 'Requesting' : 'Request'}
              </button>
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    );
  }

}

NewStory.propTypes = {
  allStories: PropTypes.array.isRequired,
  getStories: PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  errorInStories: PropTypes.array,
  requestingStories: PropTypes.bool.isRequired,
  completedStories: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  addStory: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  storiesPaginateDataChanged: PropTypes.func.isRequired,
  sortByIndex: PropTypes.number.isRequired,
  fileteredStoriesCount: PropTypes.number.isRequired
}

NewStory.defaultProps = {
  errorInStories: null,
}

export default connect(
  (state, ownProps) => {
    const {
      stories: { allStories, errorInStories, requestingStories, completedStories, storiesPaginateData },
      getCategories: { categories },
      auth: { user }
    } = state;
    const { sortByIndex, fileteredStoriesCount } = storiesPaginateData;
    return {
      allStories, categories, user, errorInStories, requestingStories, completedStories, sortByIndex, fileteredStoriesCount
    }
  },
  actions,
  (stateProps, dispatchProps) => Object.assign({}, stateProps, dispatchProps)
)(withRouter(NewStory))



// WEBPACK FOOTER //
// ./src/containers/Stories/NewStory.js